<template>
  <div class="body">
    <div class="main_container">
      <training-header></training-header>
      <div class="right_col" role="main" style="margin-left: 0;">
        <br />
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="x_panel qestion_page">
              <div class="x_title">
                <h2>Certified Solutions Expert Exam</h2>
                <h2 class="examid float-right">EXAM ID NO: {{examId}}</h2>
                <div class="circle-wrap hide">
                  <div class="circlediv">
                    <h3>
                      0%
                      <br />
                      <span>Score</span>
                    </h3>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
              <div class="x_content" style="margin-top: 3%;">
                <div class="dashboard-widget-content">
                  <question v-if="questionObj" :questionObj="questionObj" :review="true" :index="index"></question>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="question_number_container">
                        <template v-for="(item, i) in quesLen" >
                          <div :class="{ 'active': i === index }" :key="i">{{item}}</div>
                        </template>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="button-div" style="padding-top: 5%; padding-bottom: 5%;">
                        <a href="#" class="btn btn-primary" role="button" @click="back" v-if="index+1 == questionArr.length" style="padding: 6px 40px;">Back to Scoreboard</a>
                        <a href="#" class="btn btn-secondary" role="button" v-else @click="getQuestion" style="padding: 6px 40px;">Next</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /page content -->

      <!-- footer content -->
      <training-footer></training-footer>
      <!-- /footer content -->
    </div>
  </div>
</template>
<script>
import trainingHeader from "../components/trainingHeader";
import trainingFooter from "../components/trainingFooter";
import question from "./question";
import ApiServices from '../service/ApiServices';
export default {
  components: {
    trainingHeader,
    trainingFooter,
    question
  },
  data(){
      return {
         examId: null,
         questionArr: [],
         quesLen: [],
         index: 0,
         questionObj: null,
         answer: null,
         answerArr: []
      }
  },
  methods:{
      back(){
          this.$router.push("/score-board");
      },
      getQuestion(){
        this.index++
        this.questionObj = this.questionArr[this.index]
        let objIndex = this.questionObj.options.findIndex((obj => obj.selected == true || obj.selected == false));
        let attempted = false
        this.questionObj.options.forEach((obj => {
          if(obj.selected == true || obj.selected == false){
            attempted = true
          }
        }));
        this.questionObj['attempted'] = attempted

        this.questionObj.options.forEach(element => {
            if(element.correctAnswer && element.selected){
                element['styleClass'] = 'active'
            }else if(element.correctAnswer && element.selected == undefined){
                element['styleClass'] = 'active'
            }else if(element.correctAnswer && !element.selected){
                element['styleClass'] = 'wrong'
            }else if(!element.correctAnswer && element.selected){
                element['styleClass'] = 'wrong'
            }
        });
        //console.log(this.questionObj)
      },
      getQuestionList(){
        this.$root.loading = true;
        let resId = JSON.parse(localStorage.getItem("score-board")).responseId;
        let obj = {responseId: resId,courseId:54097}
        ApiServices.RestPostCall('api/avenir/training/reviewExamResult',obj).then(res => {
          console.log(res)
            this.$root.loading = false;
            this.examId = res.examDetails.examId
            this.questionArr = res.examDetails.questionResponses
            this.questionObj = this.questionArr[this.index]
            let attempted = false
            this.questionObj.options.forEach((obj => {
              if(obj.selected == true || obj.selected == false){
                attempted = true
              }
            }));
            this.questionObj['attempted'] = attempted
            this.questionObj.options.forEach(element => {
                if(element.correctAnswer && element.selected){
                    element['styleClass'] = 'active'
                }else if(element.correctAnswer && element.selected == undefined){
                    element['styleClass'] = 'active'
                }else if(element.correctAnswer && !element.selected){
                    element['styleClass'] = 'wrong'
                }else if(!element.correctAnswer && element.selected){
                    element['styleClass'] = 'wrong'
                }
            });
           //console.log(this.questionObj)
            for(let i in this.questionArr){
              this.quesLen.push(Number(i)+1)
            }
        }).catch((error) => {
          this.$root.loading = false;
            console.log(error)
        })
      }
  },
  mounted(){
    this.getQuestionList()
  }
};
</script>
<style scoped>
.x_panel {
  background-color: #fff;
  border: 0px solid transparent;
  padding: 0;
  border-radius: 7px;
}
.x_title {
  border-bottom: 0px solid #e6e9ed;
  padding: 15px 18px;
  background-color: #b0b0b0;
  color: #fff;
  border-radius: 7px 7px 0 0;
}
.x_content {
  padding: 0 25px 6px;
}
.button-div {
  display: flex;
  justify-content: center;
  margin-bottom: 4%;
}
</style>
